<template>
  <div class="list-box" style="padding: 0">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="姓名"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="payroll-record-table"
        size="large"
        @row-click="onRowClick"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          align="center"
        />
        <el-table-column
          label="算税状态"
          sortable="tax_status"
          width="120"
          align="center"
        >
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.tax_failure_msg"
              v-if="row.tax_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_tax_status"
              :value="row.tax_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          label="发放状态"
          sortable="pay_status"
          width="120"
          align="center"
        >
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.pay_failure_msg"
              v-if="row.pay_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_pay_status"
                  :value="row.pay_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_pay_status"
              :value="row.pay_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          label="报送状态"
          sortable="declare_status"
          width="120"
          align="center"
        >
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.declare_failure_msg"
              v-if="row.declare_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="employeedeclare_declare_status"
              :value="row.declare_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :width="140"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.name"
          v-for="item in state.templateSortFields.filter(
            (w) => w.field != 'remark'
          )"
          :key="item"
          :width="['idcard'].includes(item.field) ? 180 : 140"
          align="center"
        >
          <template #default="{ row, column }">
            <div
              v-if="row.isEdit && row.edit.includes(column.property)"
              @click.stop=""
            >
              <el-input-number
                v-model="row[column.property]"
                style="width: 100%"
                :precision="2"
                controls-position="right"
              ></el-input-number>
            </div>
            <template v-else>
              <div v-if="row[column.property]">
                {{ row[column.property] }}
              </div>
              <text v-else>-</text>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :width="180" align="center">
          <template #default="{ row }">
            <el-input
              v-model="row.remark"
              v-if="row.isEdit"
              @click.stop=""
            ></el-input>
            <text v-else>
              {{ row.remark || "-" }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('104')"
        >
          <template #default="{ row, $index }">
            <template v-if="!row.isEdit">
              <el-button
                type="primary"
                link
                icon="Edit"
                @click.stop="row.isEdit = true"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                link
                icon="Delete"
                @click.stop="onDelete(row.id)"
              >
                删除
              </el-button>
            </template>
            <template v-else>
              <el-button
                type="success"
                link
                icon="Select"
                @click.stop="onSubmit(row)"
              >
                保存
              </el-button>
              <el-button
                type="info"
                link
                icon="Close"
                @click.stop="onCancel($index)"
              >
                取消
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref, h } from "vue";
import { payroll_employee } from "@/http/api";
import { priceFormat } from "@/utils/qFormat";

export default {
  props: {
    payroll_id: Number,
    model: Object,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      params: {},
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
      setAgentModel: {},
    });
    onMounted(() => {
      state.params.payroll_id = props.payroll_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      payroll_employee(state.params).then((res) => {
        if (res.status == 200) {
          const { list, statistics, templateSortFields } = res.data.data;
          state.tableData = list;
          state.statistics = statistics;
          state.templateSortFields = templateSortFields;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      }
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) {
          res[index + 6] = priceFormat(state.statistics[key]);
        }
      });

      return res;
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onSortChange,
      getSummaries,
    };
  },
};
</script>
<style lang="less">
.payroll-dialog {
  .el-dialog__body {
    flex: 1;
    overflow: hidden;
  }
}
</style>
